import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';

const DebugIT = () => {
  const { user, token } = useAuth();
  const location = useLocation();

  console.log('=== IT Debug Information ===');
  console.log('Current location:', location.pathname);
  console.log('User object:', user);
  console.log('Token exists:', !!token);
  console.log('User role:', user?.role);
  console.log('User ID:', user?.id);
  console.log('User name:', user?.name);
  console.log('User university:', user?.university);
  console.log('============================');

  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">IT Debug Information</h1>
      
      <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-lg font-semibold mb-4">Authentication Status</h2>
        <div className="space-y-2">
          <p><strong>Current Path:</strong> {location.pathname}</p>
          <p><strong>User Logged In:</strong> {user ? 'Yes' : 'No'}</p>
          <p><strong>Token Exists:</strong> {token ? 'Yes' : 'No'}</p>
          <p><strong>User Role:</strong> {user?.role || 'Not set'}</p>
          <p><strong>User ID:</strong> {user?.id || 'Not set'}</p>
          <p><strong>User Name:</strong> {user?.name || 'Not set'}</p>
          <p><strong>User University:</strong> {user?.university || 'Not set'}</p>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow mt-4">
        <h2 className="text-lg font-semibold mb-4">Raw User Object</h2>
        <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
          {JSON.stringify(user, null, 2)}
        </pre>
      </div>

      <div className="bg-white p-6 rounded-lg shadow mt-4">
        <h2 className="text-lg font-semibold mb-4">Navigation Test</h2>
        <div className="space-x-4">
          <a href="/it/dashboard" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            Go to IT Dashboard
          </a>
          <a href="/dashboard" className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
            Go to Main Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default DebugIT;
